module.exports = __webpack_public_path__ + "static/energy_21-cfb60ba5c9d20d5de1fa037fdfa7f498.jpg";